<template>
<v-card >
  <v-card-title class='subtitle-1 overline' >
    <v-btn small icon
      @click='get'
      :loading='requests.get.loading' >
      <v-icon small >mdi-reload</v-icon></v-btn>
    Team
  </v-card-title>
  <v-divider />
  <v-card-text>
    <v-list three-line class='mt-2' subheader >
      <template v-for='(member, index) in activeTeamMembers' >
        <team-member-list-item
          :to="`/settings/spaces/${spaceId}/members/${member.id}`"
          v-model='members[index]'
          :key='member.id' >
        </team-member-list-item>
        <v-divider :key='`div-${member.id}`' ></v-divider>
      </template>
    </v-list>

    <template v-if='pendingInvites && pendingInvites.length > 0' >
      <v-subheader class='overline' >Pending invites</v-subheader>
      <v-list dense class='mt-2' subheader >
        <template v-for='(member, index) in pendingInvites' >
          <v-list-item :key='`div-${member.id}-${index}`' >
            <v-list-item-content >
              <v-list-item-title v-text='member.invite_email' >
              </v-list-item-title>
              <v-list-item-subtitle v-text='member.join_link' >
              </v-list-item-subtitle>
              <v-list-item-subtitle >
                Sent: {{ dateformat(member.created_date) }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action >
              <v-btn icon
                @click='showConfirmationDialog(member)'
                color='error' >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

          <v-divider :key='`div-${member.id}`' ></v-divider>
        </template>
      </v-list>
      <v-dialog v-model='confirmDelete' width='460' >
        <v-card>
          <v-card-title class='subtitle-1 overline justify-center' >
            Are you sure you want to delete this invite?
          </v-card-title>
          <v-card-text>
            <v-card-actions >
              <v-btn @click='confirmDelete=false' text >Cancel</v-btn>
              <v-spacer/>
              <v-btn
                :loading='requests.delete.loading'
                @click='deleteInvite(selectedMember)' class='error' >
                Delete invite
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>

    <template v-if='deactivatedMembers && deactivatedMembers.length > 0' >
      <v-subheader class='overline' >Deactivated members</v-subheader>
      <v-list dense >
        <v-list-item v-for='member in deactivatedMembers' :key='member.id' >
          <v-list-item-content>
            <v-list-item-title v-text="member.practitioner_name" />
          </v-list-item-content>
          <v-list-tile-action >
            <v-btn icon :to="`/settings/spaces/${spaceId}/members/${member.id}`" >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-item>
      </v-list>
    </template>

  </v-card-text>
  <v-divider />
  <v-card-actions >
    <v-spacer></v-spacer>
    <v-btn
      @click='launchInviteWizard(spaceId)' color='primary' class='mr-5' >
      <v-icon>mdi-plus</v-icon> Add a member</v-btn>
  </v-card-actions>

  <!-- <pre>{{members}}</pre> -->
  <!-- <v-dialog v-model='inviteDialog' > -->
    <!-- <v-card class='elevation-4 ma-2 grey lighten-4'>
      <v-card-title class='subtitle-1 overline' >
        Invite a new member to your team
      </v-card-title>
      <v-card-text>
        <v-text-field
          label='Email address' >
        </v-text-field>
      </v-card-text>
    </v-card> -->
  <!-- </v-dialog> -->
</v-card>
</template>
<script>
import Vue from 'vue'
import TeamMemberListItem from '@/components/listitems/TeamMemberListItem'
import {mapGetters} from 'vuex'

const MEMBER_INVITED_EVENT_ID = 'invite-member-wizard'

export default {
  name: 'TeamSettings',
  components: {TeamMemberListItem},
  props: {
    spaceId: { required: true },
    value: { type: Array, required: false }
  },
  data () {
    return {
      members: [],
      withAdd: false,
      confirmDelete: false,
      selectedMember: {},
      requests: {
        get: {
          resource: 'ag.spaces.members',
          kwargs: {spaceId: this.spaceId},
          result: {}
        },
        delete: {
          resource: 'ag.spaces.members',
          kwargs: {spaceId: this.spaceId},
          result: {}
        },
        save: {
          resource: 'ag.spaces.members',
          kwargs: {spaceId: this.spaceId},
          result: {}
        }
      },
      permissionsDialog: false
    }
  },
  methods: {
    get () {
      if (this.spaceId) {
        this.$request('get', this.requests.get)
      }
      this.init()
    },
    deleteInvite (invite) {
      console.log(invite)
      this.requests.delete.resourceId = invite.id
      this.requests.delete.kwargs = {spaceId: invite.service}
      this.$request('delete', this.requests.delete)
    },
    showConfirmationDialog (member) {
      this.confirmDelete = true
      this.selectedMember = member
    }
  },
  computed: {
    ...mapGetters(['getEventById']),
    getRequestStatus () {
      return this.requests.get.status
    },
    deleteRequestStatus () {
      return this.requests.delete.status
    },
    activeTeamMembers () {
      return this.members.filter((member) => {
        return member.is_active && member.practitioner
      })
    },
    pendingInvites () {
      return this.members.filter((member) => {
        return member.is_active === false && !member.archive_date
      })
    },
    deactivatedMembers () {
      return this.members.filter((member) => {
        return member.is_active === false && member.archive_date
      })
    },
    eventData () {
      // return MEMBER_INVITED_EVENT_ID
      return this.getEventById(MEMBER_INVITED_EVENT_ID)
    },
    eventDataStatus () {
      return this.eventData.touch
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.members = this.value }
      }
    },
    spaceId: {
      immediate: true,
      handler () {
        if (this.spaceId) {
          Vue.set(this.requests.get.kwargs, 'spaceId', this.spaceId)
          Vue.set(this.requests.save.kwargs, 'spaceId', this.spaceId)
          this.get()
        }
      }
    },
    getRequestStatus () {
      if (this.getRequestStatus === 200) {
        this.members = this.getObjectPath(this.requests, 'get.result.results', [])
      }
    },
    deleteRequestStatus () {
      if (this.deleteRequestStatus === 204) {
        this.get()
        this.confirmDelete = false
      }
    },
    eventDataStatus () {
      this.get()
    }
  }
}
</script>
